import React, { forwardRef, useRef, useEffect } from 'react'

const Radio = forwardRef(({ indeterminate, ...rest }, ref) => {
  
  const defaultRef = useRef()
  const resolvedRef = ref || defaultRef

  useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate
  }, [resolvedRef, indeterminate])

  return (
    <>
      <input type="radio" ref={resolvedRef} {...rest} />
    </>
  )
})

export default Radio